<template>
  <FKBreadCrumb :page="patient_fullname" >
    <FKBreadCrumbItem :page="$t('page.patients')" to="/patients"/>
  </FKBreadCrumb>
  <div class="row">
    <div class="col-xxl-12">
      <PatientAnagraph/>
      <TherapyView />
      <SurveyCardsList />
    </div>
    <div class="col-12 col-lg-6" v-if="config.feature.events">
      <EventsCalendar :patient_summary="patient_summary" class="h-100" />
    </div>
    <div class="col-12 col-lg-6 mb-25" v-if="config.feature.messages">
      <MessagesBody :show_patient_name="false" />
    </div>
    <div class="col-xxl-12">
      <ContentPatientPermission v-if="update_enabled" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";
import TherapyView from "@/components/FK/PatientDetail/TherapyView.vue";
import PatientAnagraph from "@/components/FK/PatientDetail/PatientAnagraph.vue";
import ContentPatientPermission from "@/components/FK/Contents/Permissions/ContentPatientPermission.vue";
import EventsCalendar from "@/components/FK/Events/EventsCalendar.vue";
import MessagesBody from "@/components/FK/Messages/MessagesBody.vue";
import SurveyCardsList from "@/components/FK/Surveys/SurveyCardsList.vue";
import stateStore from "@/utils/store";
import { PatientInfo } from "@/utils/models/user.model";
import CONFIG from "@/utils/const/config"
import { EventUserSummary } from "@/utils/models/event.model";

export default defineComponent({
  name: "PatientPage",
  components: {
    FKBreadCrumb,
    FKBreadCrumbItem,
    PatientAnagraph,
    SurveyCardsList,
    TherapyView,
    ContentPatientPermission,
    MessagesBody,
    EventsCalendar,
  },
  computed: {
    config() { return CONFIG },
    update_enabled(): boolean { return stateStore.getCenterPermission((this.$route.meta.patient as PatientInfo).center_id, 'update') },
    patient() { return this.$route.meta.patient as PatientInfo },
    patient_summary(): EventUserSummary { return {
      id: this.patient.id,
      firstname: this.patient.firstname,
      lastname: this.patient.lastname,
    } as EventUserSummary},
    patient_fullname(): string { return (this.patient.firstname.trim().length != 0 && this.patient.lastname.trim().length != 0) ? `${this.patient.firstname} ${this.patient.lastname}` : this.patient.users?.[0]?.email ?? '' }
  }
});
</script>